import React from 'react';

import { dggTheme } from '../../../../styles/dggTheme';
import { ButtonLink } from '../../atoms/ButtonLink/ButtonLink';
import { Content } from '../../molecules/Content/Content';
import * as styles from './MostMisGiftedSection.styles';

interface MostMisGiftedSectionProps {
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  showCategoryLinks: boolean;
}

export const MostMisGiftedSection = ({
  onLinkClick,
  showCategoryLinks,
}: MostMisGiftedSectionProps) => {
  return (
    <div css={styles.root}>
      <Content backgroundColor={dggTheme.colors.goblin}>
        <div css={styles.socks}>
          <h4>8,675,361 socks</h4>
          <p>50% of socks also ended up shoved at the back of the drawer, never to be used. Sob.</p>
          {showCategoryLinks && (
            <ButtonLink
              onClick={onLinkClick}
              href="/christmas/christmas-clothing-accessories/festive-socks"
              text="Give better socks"
              backgroundColor={dggTheme.colors.sulu}
              textColorMode="dark"
            />
          )}
        </div>
        <div css={styles.mugs}>
          <h4>4,495,006 mugs</h4>
          <p>
            The reason these mugs missed the mark? They didn’t match existing decor or the
            recipient’s taste. Oops.
          </p>
          {showCategoryLinks && (
            <ButtonLink
              onClick={onLinkClick}
              href="/home/kitchen/tableware/mugs"
              text="Give better mugs"
              backgroundColor={dggTheme.colors.sulu}
              textColorMode="dark"
            />
          )}
        </div>
        <div css={styles.bath}>
          <h4>6,113,208 bath products</h4>
          <p>
            36% of smellies were regifted, too. People said poor-quality products, disliking scents
            and generic-feeling gifts were to blame.
          </p>
          {showCategoryLinks && (
            <ButtonLink
              onClick={onLinkClick}
              href="/health-beauty/bath-body"
              text="Give better bath products"
              backgroundColor={dggTheme.colors.sulu}
              textColorMode="dark"
            />
          )}
        </div>
      </Content>
    </div>
  );
};
